import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteDiagnosisPopupIcon } from "../../assets/svg/delete-new-icon.svg";
import { ErrorButton, OutlinedButton, PrimaryButton } from "../customComponent/Button";
import { PopupStyledModal } from "../customComponentNewDesign/CustomPopupModal";
import { font18pxSB } from "../Typography";
import styled from "styled-components";
import { PRIMARY_600 } from "../../constant/colors";
import { focusRing } from "./focusRing";

const DialogTitle = styled.p`
  ${font18pxSB}
`;

// TMCore secondary button states (design system 878:2712): hover and focus turn the border/text
// Primary 600, focus adds the Primary 200 ring.
const ModalCancelButton = styled(OutlinedButton)`
  &:hover {
    color: ${PRIMARY_600};
    border-color: ${PRIMARY_600};
  }

  /* pressed or keyboard focus: design-system ring (TMCore 1042:8331), Primary instead of Error */
  &:active,
  &:focus-visible {
    color: ${PRIMARY_600};
    ${focusRing}
  }
`;

const DiscardChangesPopup = ({
  visible = true,
  onClickDiscard = () => {},
  onClickCancel = () => {},
  popupTitle,
  popupDescription,
  okText,
  cancelText,
  usePrimaryButton = false,
  icon = <DeleteDiagnosisPopupIcon />
}) => {
  const { t } = useTranslation();
  const OkButton = usePrimaryButton ? PrimaryButton : ErrorButton;
  return (
    <PopupStyledModal
      title={icon}
      open={visible}
      closable={false}
      footer={[
        <ModalCancelButton key="back" onClick={onClickCancel} id="discard_changes_cancel">
          {cancelText || t("back")}
        </ModalCancelButton>,
        <OkButton key="ok" onClick={onClickDiscard} id="discard_changes_ok">
          {okText || t("approve_discard")}
        </OkButton>
      ]}
    >
      <DialogTitle>{popupTitle}</DialogTitle>
      {popupDescription ? popupDescription : t("cancel_modal_description")}
    </PopupStyledModal>
  );
};

DiscardChangesPopup.propTypes = {
  visible: PropTypes.bool,
  onClickDiscard: PropTypes.func,
  onClickCancel: PropTypes.func,
  popupTitle: PropTypes.node,
  popupDescription: PropTypes.node,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  usePrimaryButton: PropTypes.bool,
  icon: PropTypes.node
};

export default DiscardChangesPopup;
